import React from 'react';
import { graphql } from 'gatsby';

import { Layout } from 'soluble-gatsby-source';

import BreadcrumbSection from '../components/BreadcrumbSection';
import HeaderSection from '../components/HeaderSection';
import BlogPostComponent from '../components/BlogPostComponent';

export default function Post({ data, pageContext }) {
    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            document.documentElement.classList.add('template-api');
            document.documentElement.classList.add('template-post');
            document.documentElement.style.fontSize = '16px';
        }
    }, []);
    return (
        <Layout navbarFixed={true}>
            <BreadcrumbSection
                home={data.home}
                page={{
                    title: data.post.title,
                    treeParent: data.post.parentPage,
                }}
            />
            {data.post && data.post.bgImage && data.post.bgImage.node ? (
                <HeaderSection
                    bgImage={{ file: data.post.bgImage.node.localFile }}
                    bgImageWebp={
                        data.post.bgImageWebp && data.post.bgImageWebp.node
                            ? { file: data.post.bgImageWebp.node.localFile }
                            : null
                    }
                    pt={{ xs: 20, lg: 30 }}
                    pb={{ xs: 20, lg: 30 }}
                />
            ) : null}
            {data.post ? (
                <BlogPostComponent
                    pageUrl={pageContext.pageUrl}
                    {...data.post}
                />
            ) : null}
        </Layout>
    );
}

export const query = graphql`
    query Post($id: String, $language: String) {
        home: datoCmsPage(slug: { eq: "" }, locale: { eq: $language }) {
            id
            slug
            title
        }

        post: wpPost(id: { eq: $id }) {
            ...BlogItemMetas
            title
            by
            content
            parentPage {
                title
                slug
                treeParent {
                    title
                    slug
                    treeParent {
                        title
                        slug
                        treeParent {
                            title
                            slug
                        }
                    }
                }
            }
            authorPage {
                title
                slug
            }
            bgImage: featuredImage {
                node {
                    localFile {
                        publicURL
                        childImageSharp {
                            resize(
                                width: 2880
                                height: 1028
                                cropFocus: CENTER
                                quality: 90
                                traceSVG: { color: "#000529" }
                            ) {
                                src
                                tracedSVG
                            }
                        }
                    }
                }
            }
            bgImageWebp: featuredImage {
                node {
                    localFile {
                        childImageSharp {
                            resize(
                                width: 2880
                                height: 1028
                                cropFocus: CENTER
                                quality: 90
                                toFormat: WEBP
                            ) {
                                src
                            }
                        }
                    }
                }
            }
            tableOfContents {
                title
                slug
            }
            relatedPosts {
                ...BlogItem
            }
        }
    }
`;
